import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { DataNameAllow, LocaleAllow, SchemaData } from '../../../types/IHeader';
import { SchemaOrg } from '../SchemaOrg';
import { Seo } from '../Seo';
import { getPostMeta } from '../utils';

export type ContextData = {
  id: string;
  locale: LocaleAllow;
  ownerNodeId: string;
  slug: string;
};

export type HeadWrapperProps = {
  data: SchemaData;
  location: { pathname: string };
  pageContext: ContextData;
  templateName: string;
  dataName: DataNameAllow;
};

export function HeadWrapper({
  data,
  dataName,
  pageContext,
  templateName,
  location,
}: HeadWrapperProps) {
  const settingsData = useStaticQuery<any>(graphql`
    query PostMetaQuery {
      seofr: datoCmsSite(locale: "fr") {
        ...Site
      }
      seoen: datoCmsSite(locale: "en") {
        ...Site
      }
      seoes: datoCmsSite(locale: "es") {
        ...Site
      }
      settingfr: datoCmsSetting(locale: "fr") {
        ...Setting
      }
      settingen: datoCmsSetting(locale: "en") {
        ...Setting
      }
      settinges: datoCmsSetting(locale: "es") {
        ...Setting
      }
    }
  `);

  const postMeta = getPostMeta(settingsData, pageContext.locale);

  return (
    <>
      <Seo
        data={data[dataName]}
        locale={pageContext?.locale}
        postMeta={postMeta}
      />
      <SchemaOrg
        {...{
          data,
          dataName,
          templateName,
          pageContext,
          location,
          postMeta,
        }}
      />
    </>
  );
}
